module.exports = __webpack_public_path__ + "img/error-icon.24ac4ce4.png";